import i18n from '@/i18n';

type Translate = (key: string, options: { defaultValue: string }) => string;

const labels = {
  dedicated: {
    fullKey: 'common.contentType.youtubeDedicated',
    full: 'YouTube dedicated long-form video',
    shortKey: 'deals.content_type.dedicated_video',
    short: 'Dedicated long-form video'
  },
  integrated: {
    fullKey: 'common.contentType.youtubeIntegrated',
    full: 'YouTube integrated long-form video',
    shortKey: 'deals.content_type.integrated_video',
    short: 'Integrated long-form video'
  }
};

/** Display only: never use the returned label as a content type or request value. */
export function getYouTubeContentTypeLabel({
  platform,
  contentType,
  t = (key, options) => i18n.t(key, options),
  includePlatform = false
}: {
  platform?: unknown;
  contentType?: string;
  t?: Translate;
  includePlatform?: boolean;
}): string | undefined {
  if (
    String(platform ?? '')
      .trim()
      .toLowerCase() !== 'youtube'
  )
    return;
  const type = String(contentType ?? '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')
    .replace(/^youtube/, '');
  const kind = /^(dedicated|integrated)(?:video|longformvideo)?$/.exec(
    type
  )?.[1];
  if (kind !== 'dedicated' && kind !== 'integrated') return;
  const label = labels[kind];
  const text = includePlatform
    ? t(label.fullKey, { defaultValue: label.full })
    : t(label.shortKey, { defaultValue: label.short });
  return includePlatform ? text : text.charAt(0).toUpperCase() + text.slice(1);
}
